import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const MODULE_NAME = new InjectionToken<string | Observable<string>>('Module name');
